import TranslatableTypography from "app/components/shared/TranslatableTypography";
import { makeColumnsResponsive } from "app/shared/utils";
import { Theme } from "common";

/**
 * History Table MUI Column configuration
 *
 * @see https://mui.com/x/react-data-grid/column-definition/
 */
export const getTableColumnHeaders = () => {
  const tableColumns = [
    {
      field: "protocolNumber",
      renderHeader: () => (
        <TranslatableTypography tlEntry="eProtocol.table.columnName.protocolNumber" />
      ),
      sortable: false,
      width: 160,
    },
    {
      field: "reviewDate",
      renderHeader: () => (
        <TranslatableTypography tlEntry="eProtocol.table.columnName.reviewDate" />
      ),
      sortable: false,
      width: 120,
    },
    {
      field: "submitDate",
      renderHeader: () => (
        <TranslatableTypography tlEntry="eProtocol.table.columnName.submitDate" />
      ),
      sortable: false,
      width: 120,
    },
    {
      field: "actionDate",
      renderHeader: () => (
        <TranslatableTypography tlEntry="eProtocol.table.columnName.actionDate" />
      ),
      sortable: false,
      width: 110,
    },
    {
      field: "eventDate",
      renderHeader: () => (
        <TranslatableTypography tlEntry="eProtocol.table.columnName.eventDate" />
      ),
      sortable: false,
      width: 110,
    },
    {
      field: "reviewReason",
      renderHeader: () => (
        <TranslatableTypography tlEntry="eProtocol.table.columnName.reviewReason" />
      ),
      sortable: false,
      width: 175,
    },
    {
      field: "reviewType",
      renderHeader: () => (
        <TranslatableTypography tlEntry="eProtocol.table.columnName.reviewType" />
      ),
      sortable: false,
      width: 120,
    },
    {
      field: "action",
      renderHeader: () => (
        <TranslatableTypography tlEntry="eProtocol.table.columnName.action" />
      ),
      sortable: false,
      width: 100,
    },
    {
      field: "expirationDate",
      renderHeader: () => (
        <TranslatableTypography tlEntry="eProtocol.table.columnName.expirationDate" />
      ),
      sortable: false,
      width: 145,
    },
    {
      field: "institution",
      renderHeader: () => (
        <TranslatableTypography tlEntry="eProtocol.table.columnName.institution" />
      ),
      sortable: false,
      width: 261,
    },
    {
      field: "irbCommittee",
      renderHeader: () => (
        <TranslatableTypography tlEntry="eProtocol.table.columnName.irbCommittee" />
      ),
      sortable: false,
      width: 160,
    },
  ];

  // MUI thought it'd be a great idea to deprecate the 'hide' property.
  // The new columnVisibilityModel is overly complex for what we need &
  // more geared to user-interaction to show/hide a column:
  // @see https://mui.com/x/react-data-grid/column-visibility/#initialize-the-visible-columns
  return makeColumnsResponsive(tableColumns.filter((c) => !c.hide));
};

export const tableStyles = {
  boxShadow: 3,
  borderRadius: "8px",
  width: "100%",
  "& .MuiDataGrid-columnHeader": {
    "& .MuiDataGrid-columnHeaderTitle": {
      fontSize: "14px",
      fontWeight: 400,
    },
    "&:focus": {
      outline: "none !important",
    },
    "&:focus-within": {
      outline: "none !important",
    },
  },
  "& .MuiDataGrid-columnHeader--last .MuiDataGrid-columnSeparator": {
    display: "none",
  },
  "& .MuiDataGrid-columnSeparator": {
    visibility: "visible",
  },
  "& .MuiDataGrid-cell": {
    fontSize: "14px",
    display: "flex",
    alignItems: "center",
    "&:focus": {
      outline: "none !important",
    },
    "&:focus-within": {
      outline: "none !important",
    },
  },
  "& .MuiTablePagination-root": {
    "& .MuiTablePagination-selectLabel": {
      fontSize: "14px",
    },
    "& .MuiTablePagination-displayedRows": {
      fontSize: "14px",
    },
    fontSize: "14px",
  },
  "&& .MuiIconButton-root": {
    width: "1em",
    height: "1em",
  },
  "& .Mui-odd": {
    backgroundColor: "#F0F4F5",
    "&:hover": {
      backgroundColor: "#F0F4F5",
    },
  },
  "& .Mui-even": {
    "&:hover": {
      backgroundColor: Theme.palette.primary.contrastText,
    },
  },
  "& .MuiCheckbox-root": {
    padding: "0px",
  },
  "&.MuiDataGrid-root--densityStandard .MuiDataGrid-cell": {
    minHeight: "52px !important",
    padding: "5px 10px",
  },
  "& .MuiDataGrid-columnHeaderCheckbox": {
    minWidth: "30px !important",
    width: "30px !important",
    "& .MuiDataGrid-columnSeparator": {
      display: "none",
    },
  },
  "& .MuiDataGrid-cellCheckbox": {
    minWidth: "30px !important",
    width: "30px !important",
    padding: "0px !important",
  },
};
